import { createContext, useContext, useEffect, useState } from "react";
import api, { fmtPrice } from "@/lib/api";

const CurrencyContext = createContext(null);

const FALLBACK_TIERS = [
  { id: "basic", label: "Basic", games: false, devices: "Phone & Computer", amount: 19.99, link: "https://paystack.shop/pay/qch2krl57k" },
  { id: "standard", label: "Standard", games: false, devices: "All devices", amount: 24.99, link: "https://paystack.shop/pay/oqhnp4eyya" },
  { id: "premium", label: "Premium", games: true, devices: "All devices", amount: 29.99, link: "https://paystack.shop/pay/uyh9-pdw75" },
];

// Single currency: South African Rand (ZAR). No localisation / conversion.
export function CurrencyProvider({ children }) {
  const [state, setState] = useState({ currency: "ZAR", converted: false, trialHours: 24, tiers: FALLBACK_TIERS, freeAccess: true, loading: true });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/subscription/localized-price");
        if (!cancelled) setState({ currency: "ZAR", converted: false, trialHours: data.trial_hours || 24, tiers: data.tiers || FALLBACK_TIERS, freeAccess: !!data.free_access, loading: false });
      } catch {
        if (!cancelled) setState((s) => ({ ...s, loading: false }));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const tiers = (state.tiers || FALLBACK_TIERS).map((t) => {
    const amt = t.amount ?? t.zar_amount;
    return { ...t, amount: amt, display: fmtPrice("ZAR", amt), zarDisplay: fmtPrice("ZAR", amt) };
  });
  const fromDisplay = tiers[0]?.display;

  return (
    <CurrencyContext.Provider value={{ ...state, currency: "ZAR", converted: false, tiers, fromDisplay, display: fromDisplay }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
